const observer = new MutationObserver(() => {
  const elements = document.getElementsByClassName('kl-private-reset-css-Xuajs1');

  for (let i = 0; i < elements.length; i++) {
    const el = elements[i];

    if (el.tagName === 'IMG' && !el.hasAttribute('alt')) {
      el.setAttribute('alt', 'Alexapure logo');
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});